import React, { useEffect, useState } from 'react';
import { getServices, createService, updateService, deleteService } from './api';

export default function ServicesAdmin(){
  const [items, setItems] = useState<any[]>([]);
  const [editing, setEditing] = useState<any>(null);

  useEffect(() => { load(); }, []);

  async function load(){
    const data = await getServices();
    setItems(data);
  }

  function edit(it: any){ setEditing({ ...it }); }
  function reset(){ setEditing(null); }

  async function save(){
    try{
      if (editing.id) await updateService(editing);
      else await createService(editing);
      await load(); reset();
    }catch(e){ console.error(e); alert('Save failed'); }
  }

  async function onDelete(id: number){ if (!window.confirm('Delete service?')) return; await deleteService(id); await load(); }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold">Services</h2>
        <button onClick={() => setEditing({ title: '', slug: '', description: '' })} className="bg-sky-600 text-white px-3 py-1 rounded">New</button>
      </div>
      <div className="grid gap-2">
        {items.map(it => (
          <div key={it.id} className="p-2 border rounded flex justify-between">
            <div>
              <div className="font-medium">{it.title}</div>
              <div className="text-sm text-slate-600">{it.slug}</div>
            </div>
            <div className="flex gap-2">
              <button onClick={() => edit(it)} className="px-2 py-1 border rounded">Edit</button>
              <button onClick={() => onDelete(it.id)} className="px-2 py-1 border rounded text-rose-600">Delete</button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="mt-4 p-3 border rounded bg-white">
          <label className="block mb-1">Title</label>
          <input placeholder="Title" value={editing.title} onChange={e=>setEditing({...editing, title:e.target.value})} className="w-full p-2 border rounded mb-2" />
          <label className="block mb-1">Slug</label>
          <input placeholder="slug" value={editing.slug} onChange={e=>setEditing({...editing, slug:e.target.value})} className="w-full p-2 border rounded mb-2" />
          <label className="block mb-1">Description</label>
          <textarea placeholder="Description" value={editing.description} onChange={e=>setEditing({...editing, description:e.target.value})} className="w-full p-2 border rounded mb-2" />
          <div className="flex gap-2"><button onClick={save} className="bg-sky-600 text-white px-3 py-1 rounded">Save</button><button onClick={reset} className="px-3 py-1 border rounded">Cancel</button></div>
        </div>
      )}
    </div>
  );
}
